import {apiService as api} from 'app/store/apiService';

import {ENV} from '@/constants/EnvConstants';
import {HttpMethod} from '@/constants/httpMethod';
import {GetTokenInput} from '@/services';

export const addTagTypes = ['ResetPasswordApiTag'] as const;

const ResetPasswordApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: build => ({
      resetPasswordUsers: build.mutation<
        IRecoveryPasswordTokens,
        Partial<GetTokenInput>
      >({
        query: body => ({
          url: `${ENV.VITE_APIS_USERS_DOMAIN_URL}/auth/get_token`,
          method: HttpMethod.POST,
          data: body,
        }),
      }),
    }),
    overrideExisting: false,
  });

export default ResetPasswordApi;

export type ExampleApiArg = any;

export const {useResetPasswordUsersMutation} = ResetPasswordApi;

export type ExampleApiType = {
  [ResetPasswordApi.reducerPath]: ReturnType<typeof ResetPasswordApi.reducer>;
};

export interface IRecoveryPasswordTokens {
  code: string;
}
